import { useEffect, useState } from "react";
import { callParkDetailsEndpoint } from "../api";
import { DEFAULT_FIRST_FORM_VALUE, useFilterStore } from "../stores/FilterStore";
import { useGetAreaListingData } from "./useGetAreaListingData";
import { capitalize } from "../utils";

export const useGetRegionIDAndParkIDsInRegion = () => {
  const { county } = useFilterStore(["county"]);
  const { data: areaListingData } = useGetAreaListingData();

  const [regionIDs, setRegionIDs] = useState<string[]>([]);
  const [parkOpIDs, setParkOpIDs] = useState<string[]>([]);

  useEffect(() => {
    const getRegionIDsInRegion = async () => {
      if (county === DEFAULT_FIRST_FORM_VALUE) return [regionIDs, parkOpIDs];

      const improvedDataStructure = Object.assign({}, ...(areaListingData ?? []));
      const parksInCounty = improvedDataStructure[capitalize(county)];
      const improveParkInCountyStructure = Object.assign({}, ...parksInCounty);
      const parkNamesList = Object.keys(improveParkInCountyStructure);

      const regionNumbers: string[] = [];
      const parkOpIds: string[] = [];
      await Promise.all(parkNamesList.map((name) => callParkDetailsEndpoint(name))).then(
        (values) => {
          values.forEach((val) => {
            regionNumbers.push(val.regn);
            parkOpIds.push(val.opId);
          });
        }
      );

      const uniqueRegionNumber = [...new Set(regionNumbers)];
      const uniqueParkOpIds = [...new Set(parkOpIds)];

      setRegionIDs(uniqueRegionNumber);
      setParkOpIDs(uniqueParkOpIds);
    };

    if (areaListingData) {
      getRegionIDsInRegion();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [areaListingData, county]);

  return [regionIDs, parkOpIDs];
};
